'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('chart-of-accounts', {
      url: '/accounting/accounts',
      template: '<chart-of-accounts></chart-of-accounts>'
    });
}



// WEBPACK FOOTER //
// ./client/app/accounting/chart-of-accounts/chart-of-accounts.routes.js